import { useParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ScrollToTop from "@/components/feature/ScrollToTop";
import CategoryTabs from "@/components/feature/CategoryTabs";
import ArticleCard from "@/components/feature/ArticleCard";
import SchemaOrg from "@/components/feature/SchemaOrg";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const filteredArticles = slug ? articles.filter((a) => a.category === slug) : articles;

  const categoryName = category ? category.name : "全部内容";
  const categoryDesc = category ? category.description : "浏览探花精选全部优质内容";

  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${categoryName} - 探花精选`,
          url: `https://pkgogo.cn/category/${slug || ""}`,
          description: categoryDesc,
          breadcrumb: {
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: "https://pkgogo.cn" },
              { "@type": "ListItem", position: 2, name: categoryName },
            ],
          },
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: categoryName },
              ]}
            />
          </div>

          <section className="py-8 md:py-12 bg-background-100">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex items-center gap-4 mb-2">
                {category && (
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50">
                    <i className={`${category.icon} text-lg text-primary-500`}></i>
                  </div>
                )}
                <div>
                  <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                    {categoryName}
                  </h1>
                  <p className="mt-1 text-sm text-foreground-500">{categoryDesc}</p>
                </div>
              </div>

              <div className="mt-6">
                <CategoryTabs />
              </div>
            </div>
          </section>

          <section className="py-8 md:py-12">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              {filteredArticles.length > 0 ? (
                <>
                  <p className="text-sm text-foreground-400 mb-5">
                    共找到 <strong className="text-foreground-700">{filteredArticles.length}</strong> 篇内容
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                    {filteredArticles.map((article) => (
                      <ArticleCard key={article.id} article={article} size="medium" />
                    ))}
                  </div>
                </>
              ) : (
                <div className="text-center py-20">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-background-100 mx-auto mb-4">
                    <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                  </div>
                  <p className="text-foreground-500">该分类暂无内容，敬请期待</p>
                </div>
              )}
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}